(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bzy-xxj-lll"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(root){
    if(!root || root.dataset.ps23Ready === 'true') return;
    root.dataset.ps23Ready = 'true';

    const grid = root.querySelector('[data-product-grid]');
    const gridToggle = root.querySelector('[data-grid-toggle]');
    const gridBars = root.querySelector('[data-grid-bars]');
    const sortToggle = root.querySelector('[data-sort-toggle]');
    const sortLabel = root.querySelector('[data-sort-label]');

    let columns = 3;

    function setColumns(nextColumns){
      if(!grid) return;

      columns = nextColumns;
      grid.style.gridTemplateColumns = 'repeat(' + columns + ', minmax(0,1fr))';

      if(gridBars){
        gridBars.textContent = '|'.repeat(columns);
      }

      if(gridToggle){
        gridToggle.setAttribute(
          'aria-label',
          'Show ' + columns + ' products per row. Click to change.'
        );
        gridToggle.title = 'Show ' + columns + ' products per row';
      }
    }

    setColumns(3);

    if(gridToggle){
      gridToggle.addEventListener('click',function(){
        const next = columns === 3 ? 4 : (columns === 4 ? 5 : 3);
        setColumns(next);
      });
    }

    if(sortToggle && grid){
      sortToggle.addEventListener('click',function(){
        const current = sortToggle.dataset.sortDirection || 'asc';
        const cards = [...grid.querySelectorAll('[data-product-card]')];

        cards.sort(function(a,b){
          const titleA = (a.dataset.productTitle || '').trim();
          const titleB = (b.dataset.productTitle || '').trim();

          return current === 'asc'
            ? titleA.localeCompare(titleB)
            : titleB.localeCompare(titleA);
        });

        cards.forEach(function(card){
          grid.appendChild(card);
        });

        const next = current === 'asc' ? 'desc' : 'asc';
        sortToggle.dataset.sortDirection = next;

        if(sortLabel){
          sortLabel.textContent =
            next === 'asc'
              ? root.dataset.sortLabelAz
              : root.dataset.sortLabelZa;
        }

        sortToggle.setAttribute(
          'aria-label',
          next === 'asc'
            ? 'Sort products alphabetically A to Z'
            : 'Sort products alphabetically Z to A'
        );
      });
    }

    function updateCountdown(){
      if(root.dataset.countdownEnabled !== 'true') return;

      const raw = root.dataset.countdownEnd;
      const end = raw ? new Date(raw).getTime() : NaN;
      if(!Number.isFinite(end)) return;

      let diff = Math.max(0,end - Date.now());

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;

      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;

      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;

      const seconds = Math.floor(diff / 1000);

      const text =
        String(days).padStart(2,'0') + 'd ' +
        String(hours).padStart(2,'0') + ':' +
        String(minutes).padStart(2,'0') + ':' +
        String(seconds).padStart(2,'0');

      root.querySelectorAll('[data-countdown]').forEach(function(node){
        node.textContent = text;
      });
    }

    if(root.dataset.countdownEnabled === 'true'){
      updateCountdown();
      window.setInterval(updateCountdown,1000);
    }
  }

  document.querySelectorAll('[data-ps23]').forEach(function(root){
    initSection(root);
  });

  document.addEventListener('shopify:section:load',function(event){
    const root = event.target && event.target.matches('[data-ps23]')
      ? event.target
      : event.target && event.target.querySelector('[data-ps23]');

    if(root){
      initSection(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dasd-dsasd-dsad"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(root){
    if(!root || root.dataset.zlp5Ready === 'true') return;
    root.dataset.zlp5Ready = 'true';

    const tabs = [...root.querySelectorAll('[data-zlp5-tab]')];
    const headers = [...root.querySelectorAll('[data-zlp5-header]')];
    const panels = [...root.querySelectorAll('[data-zlp5-panel]')];
    const fadeMs = Math.max(120,Number(root.dataset.fadeMs || 220));
    let switching = false;

    function activate(tabId,instant){
      const nextTab = tabs.find(x => x.dataset.tabId === tabId);
      const nextHeader = headers.find(x => x.dataset.tabId === tabId);
      const nextPanel = panels.find(x => x.dataset.tabId === tabId);
      const currentHeader = headers.find(x => !x.hidden);
      const currentPanel = panels.find(x => !x.hidden);

      if(!nextTab || !nextHeader || !nextPanel) return;
      if(currentPanel === nextPanel && currentHeader === nextHeader) return;
      if(switching && !instant) return;

      tabs.forEach(tab => {
        const active = tab === nextTab;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active ? 'true' : 'false');
      });

      if(instant || !currentHeader || !currentPanel){
        headers.forEach(header => {
          const active = header === nextHeader;
          header.hidden = !active;
          header.classList.toggle('is-active',active);
          header.classList.remove('is-in','is-out');
        });

        panels.forEach(panel => {
          const active = panel === nextPanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active',active);
          panel.classList.remove('is-in','is-out');
        });

        return;
      }

      switching = true;
      currentHeader.classList.add('is-out');
      currentPanel.classList.add('is-out');

      window.setTimeout(() => {
        currentHeader.hidden = true;
        currentHeader.classList.remove('is-active','is-out');

        currentPanel.hidden = true;
        currentPanel.classList.remove('is-active','is-out');

        nextHeader.hidden = false;
        nextPanel.hidden = false;

        nextHeader.classList.add('is-active','is-in');
        nextPanel.classList.add('is-active','is-in');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            nextHeader.classList.remove('is-in');
            nextPanel.classList.remove('is-in');

            window.setTimeout(() => {
              switching = false;
            },fadeMs);
          });
        });
      },Math.round(fadeMs * .7));
    }

    tabs.forEach(tab => {
      tab.addEventListener('click',() => activate(tab.dataset.tabId,false));
    });

    function initCard(card){
      if(card.dataset.cardReady === 'true') return;
      card.dataset.cardReady = 'true';

      const form = card.querySelector('.zlp5-card__form');
      const variantInput = card.querySelector('[data-variant-input]');
      const subscriptionVariantInput = card.querySelector('[data-subscription-variant-input]');
      const sellingPlanInput = card.querySelector('[data-selling-plan-input]');
      const optionButtons = [...card.querySelectorAll('[data-option-btn]')];
      const variantNodes = [...card.querySelectorAll('[data-variant-data]')];

      const subscription = card.querySelector('[data-subscription]');
      const subscriptionSwitch = card.querySelector('[data-subscription-switch]');
      const planToggle = card.querySelector('[data-plan-toggle]');
      const planPanel = card.querySelector('[data-plan-panel]');
      const subscriptionSummary = card.querySelector('[data-subscription-summary]');
      const subProductSelect = card.querySelector('[data-sub-product-select]');
      const planButtons = [...card.querySelectorAll('[data-plan-btn]')];

      const priceEl = card.querySelector('[data-card-price]');
      const singleOptionPrice = card.querySelector('[data-single-option-price]');
      const compareEl = card.querySelector('[data-card-compare]');
      const imageEl = card.querySelector('[data-card-image]');
      const badgeEl = card.querySelector('[data-card-badge]');
      const actionEl = card.querySelector('[data-card-add]');
      const productLink = card.querySelector('[data-product-link]');
      const quickToggle = card.querySelector('[data-quick-toggle]');
      const quickClose = card.querySelector('[data-quick-close]');
      const cartStatus = card.querySelector('[data-cart-status]');

      const sectionOneTimeText = root.dataset.oneTimeText || 'One-time purchase';
      const cartUrl = root.dataset.cartUrl || '/cart';

      let currentVariant = null;
      let subscriptionEnabled = false;
      let planExpanded = false;
      let lastSelectedPlanId = '';

      function selectedValues(){
        return [...card.querySelectorAll('[data-option-group]')].map(group => {
          const selected = group.querySelector('[data-option-btn].is-selected');
          return selected ? selected.dataset.optionValue : '';
        });
      }

      function findVariant(){
        const values = selectedValues();

        return variantNodes.find(node => {
          const options = [
            node.dataset.option1 || '',
            node.dataset.option2 || '',
            node.dataset.option3 || ''
          ];

          return values.every((value,index) => options[index] === value);
        }) || variantNodes[0] || null;
      }

      function selectedSubscriptionProduct(){
        if(!subProductSelect || !subProductSelect.options.length) return null;

        const option = subProductSelect.options[subProductSelect.selectedIndex];
        if(!option) return null;

        return {
          productId: option.dataset.subProductId || option.value || '',
          variantId: option.dataset.variantId || '',
          title: option.dataset.productTitle || option.textContent.trim(),
          price: option.dataset.productPrice || ''
        };
      }

      function visiblePlans(){
        const selectedProduct = selectedSubscriptionProduct();
        const visible = [];

        planButtons.forEach(button => {
          const show =
            !!selectedProduct &&
            button.dataset.subProductId === String(selectedProduct.productId) &&
            button.dataset.variantId === String(selectedProduct.variantId);

          button.hidden = !show;

          if(show){
            visible.push(button);
          }
        });

        return visible;
      }

      function setPlan(button){
        planButtons.forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-selected',selected);
          item.setAttribute('aria-pressed',selected ? 'true' : 'false');
        });

        if(!sellingPlanInput) return;

        if(!button){
          sellingPlanInput.value = '';

          if(subscriptionSummary){
            subscriptionSummary.textContent = subscriptionEnabled
              ? 'Choose delivery frequency'
              : sectionOneTimeText;
          }

          return;
        }

        const planId = button.dataset.planId || '';
        const isPreviewPlan = button.dataset.previewPlan === 'true';
        const selectedProduct = selectedSubscriptionProduct();

        if(!isPreviewPlan && planId){
          lastSelectedPlanId = planId;
        }

        sellingPlanInput.value = planId;

        if(subscriptionSummary){
          const productTitle = selectedProduct ? selectedProduct.title : '';
          const planName = button.dataset.planName || '';
          subscriptionSummary.textContent =
            productTitle && planName
              ? productTitle + ' · ' + planName
              : (planName || productTitle);
        }
      }

      function setPlanExpanded(expanded){
        if(!subscription || !planToggle || !planPanel) return;

        if(!subscriptionEnabled){
          expanded = false;
        }

        planExpanded = !!expanded;
        subscription.classList.toggle('is-expanded',planExpanded);
        planToggle.setAttribute('aria-expanded',planExpanded ? 'true' : 'false');
        planPanel.hidden = !planExpanded;
      }

      function syncSubscriptionProduct(){
        if(!subscription) return;

        const selectedProduct = selectedSubscriptionProduct();

        if(subscriptionVariantInput){
          subscriptionVariantInput.value = selectedProduct ? selectedProduct.variantId : '';
        }

        const plans = visiblePlans();

        if(!selectedProduct || !plans.length){
          if(!window.Shopify || !window.Shopify.designMode){
            subscription.hidden = true;
          }
          setPlan(null);
          return;
        }

        subscription.hidden = false;

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);
        }else{
          setPlan(null);
        }
      }

      function setSubscriptionEnabled(enabled, keepDropdownClosed){
        if(!subscription || !subscriptionSwitch) return;

        const plans = visiblePlans();

        if(!plans.length){
          subscriptionEnabled = false;
          subscription.classList.remove('is-enabled');
          subscriptionSwitch.setAttribute('aria-pressed','false');
          setPlanExpanded(false);
          setPlan(null);
          return;
        }

        subscriptionEnabled = !!enabled;
        subscription.classList.toggle('is-enabled',subscriptionEnabled);
        subscriptionSwitch.setAttribute('aria-pressed',subscriptionEnabled ? 'true' : 'false');

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);

          if(keepDropdownClosed !== false){
            setPlanExpanded(false);
          }
        }else{
          setPlanExpanded(false);
          setPlan(null);
        }
      }

      function updateLink(){
        if(!productLink || !currentVariant) return;

        const url = new URL(productLink.href,window.location.origin);
        url.searchParams.set('variant',currentVariant.dataset.id);
        url.searchParams.delete('selling_plan');

        productLink.href = url.pathname + url.search;
      }

      function syncVariant(){
        const variant = findVariant();
        if(!variant) return;

        currentVariant = variant;

        if(variantInput){
          variantInput.value = variant.dataset.id || '';
        }

        if(priceEl){
          priceEl.textContent = variant.dataset.price || '';
        }

        if(singleOptionPrice){
          singleOptionPrice.textContent = variant.dataset.price || '';
        }

        if(compareEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price){
            compareEl.textContent = variant.dataset.compare || '';
            compareEl.classList.remove('is-hidden');
          }else{
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        if(imageEl && variant.dataset.image){
          imageEl.src = variant.dataset.image;
          imageEl.removeAttribute('srcset');
        }

        if(badgeEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price && compare > 0){
            badgeEl.textContent = Math.round(((compare - price) / compare) * 100) + '% OFF';
            badgeEl.hidden = false;
          }else{
            badgeEl.hidden = true;
          }
        }

        if(actionEl){
          actionEl.disabled = variant.dataset.available !== 'true';
        }

        updateLink();
      }

      function setStatus(message,isError){
        if(!cartStatus) return;
        cartStatus.textContent = message || '';
        cartStatus.classList.toggle('is-error',!!isError);
      }

      optionButtons.forEach(button => {
        button.addEventListener('click',() => {
          const index = button.dataset.optionIndex;

          optionButtons
            .filter(x => x.dataset.optionIndex === index)
            .forEach(x => {
              const selected = x === button;
              x.classList.toggle('is-selected',selected);
              x.setAttribute('aria-pressed',selected ? 'true' : 'false');
            });

          syncVariant();
        });
      });

      if(subProductSelect){
        subProductSelect.addEventListener('change',() => {
          lastSelectedPlanId = '';
          syncSubscriptionProduct();

          if(subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }
        });
      }

      planButtons.forEach(button => {
        button.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlan(button);
          setPlanExpanded(false);
        });
      });

      if(subscriptionSwitch){
        subscriptionSwitch.addEventListener('click',(event) => {
          event.stopPropagation();
          setSubscriptionEnabled(!subscriptionEnabled,true);
        });
      }

      if(planToggle){
        planToggle.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlanExpanded(!planExpanded);
        });
      }

      if(quickToggle){
        quickToggle.addEventListener('click',() => {
          const open = !card.classList.contains('is-open');
          card.classList.toggle('is-open',open);
          quickToggle.setAttribute('aria-expanded',open ? 'true' : 'false');
        });
      }

      if(quickClose){
        quickClose.addEventListener('click',() => {
          card.classList.remove('is-open');

          if(quickToggle){
            quickToggle.setAttribute('aria-expanded','false');
          }
        });
      }

      if(form && actionEl){
        form.addEventListener('submit',async event => {
          event.preventDefault();
          setStatus('',false);

          if(!currentVariant || currentVariant.dataset.available !== 'true'){
            setStatus('This product is currently unavailable.',true);
            return;
          }

          const items = [{
            id: Number(currentVariant.dataset.id),
            quantity: 1
          }];

          if(subscriptionEnabled){
            const subVariantId = Number(subscriptionVariantInput ? subscriptionVariantInput.value : 0);
            const sellingPlanId = Number(sellingPlanInput ? sellingPlanInput.value : 0);

            if(!subVariantId || !sellingPlanId){
              setStatus('Please choose an available subscription product and delivery frequency.',true);
              setPlanExpanded(true);
              return;
            }

            items.push({
              id: subVariantId,
              quantity: 1,
              selling_plan: sellingPlanId
            });
          }

          const originalText = actionEl.textContent;
          actionEl.disabled = true;
          actionEl.textContent = 'ADDING...';

          try{
            const base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

            const response = await fetch(base + 'cart/add.js',{
              method:'POST',
              headers:{
                'Content-Type':'application/json',
                'Accept':'application/json'
              },
              body:JSON.stringify({items})
            });

            const data = await response.json();

            if(!response.ok){
              throw new Error(data && (data.description || data.message) ? (data.description || data.message) : 'Unable to add items.');
            }

            window.location.href = cartUrl;
          }catch(error){
            actionEl.disabled = false;
            actionEl.textContent = originalText;
            setStatus(error && error.message ? error.message : 'Unable to add items. Please try again.',true);
          }
        });
      }

      syncVariant();
      syncSubscriptionProduct();

      if(subscription && visiblePlans().length){
        setSubscriptionEnabled(true,true);
        setPlanExpanded(false);
      }
    }

    root.querySelectorAll('[data-zlp5-card]').forEach(initCard);

    function updateCountdowns(){
      if(root.dataset.countdownEnabled !== 'true') return;

      const endValue = root.dataset.countdownEnd;
      if(!endValue) return;

      const end = new Date(endValue).getTime();
      if(Number.isNaN(end)) return;

      const now = Date.now();
      let diff = Math.max(0,end - now);

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;

      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;

      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;

      const seconds = Math.floor(diff / 1000);

      const text =
        (days > 0 ? days + 'd ' : '') +
        String(hours).padStart(2,'0') + ':' +
        String(minutes).padStart(2,'0') + ':' +
        String(seconds).padStart(2,'0');

      root.querySelectorAll('[data-countdown]').forEach(node => {
        node.textContent = text;
      });
    }

    updateCountdowns();

    if(root.dataset.countdownEnabled === 'true'){
      root._zlp5Timer = window.setInterval(updateCountdowns,1000);
    }
  }

  function initAll(scope){
    const area = scope || document;

    if(area.matches && area.matches('[data-zlp5-root]')){
      initSection(area);
    }

    area.querySelectorAll('[data-zlp5-root]').forEach(initSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',() => initAll(document));
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',event => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload',event => {
    const root = event.target.querySelector('[data-zlp5-root]');

    if(root && root._zlp5Timer){
      window.clearInterval(root._zlp5Timer);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noteworthy-card-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(root){
    if(!root || root.dataset.zlp5Ready === 'true') return;
    root.dataset.zlp5Ready = 'true';

    const tabs = [...root.querySelectorAll('[data-zlp5-tab]')];
    const headers = [...root.querySelectorAll('[data-zlp5-header]')];
    const panels = [...root.querySelectorAll('[data-zlp5-panel]')];
    const fadeMs = Math.max(120,Number(root.dataset.fadeMs || 220));
    let switching = false;

    function activate(tabId,instant){
      const nextTab = tabs.find(x => x.dataset.tabId === tabId);
      const nextHeader = headers.find(x => x.dataset.tabId === tabId);
      const nextPanel = panels.find(x => x.dataset.tabId === tabId);
      const currentHeader = headers.find(x => !x.hidden);
      const currentPanel = panels.find(x => !x.hidden);

      if(!nextTab || !nextHeader || !nextPanel) return;
      if(currentPanel === nextPanel && currentHeader === nextHeader) return;
      if(switching && !instant) return;

      tabs.forEach(tab => {
        const active = tab === nextTab;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active ? 'true' : 'false');
      });

      if(instant || !currentHeader || !currentPanel){
        headers.forEach(header => {
          const active = header === nextHeader;
          header.hidden = !active;
          header.classList.toggle('is-active',active);
          header.classList.remove('is-in','is-out');
        });

        panels.forEach(panel => {
          const active = panel === nextPanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active',active);
          panel.classList.remove('is-in','is-out');
        });

        return;
      }

      switching = true;
      currentHeader.classList.add('is-out');
      currentPanel.classList.add('is-out');

      window.setTimeout(() => {
        currentHeader.hidden = true;
        currentHeader.classList.remove('is-active','is-out');

        currentPanel.hidden = true;
        currentPanel.classList.remove('is-active','is-out');

        nextHeader.hidden = false;
        nextPanel.hidden = false;

        nextHeader.classList.add('is-active','is-in');
        nextPanel.classList.add('is-active','is-in');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            nextHeader.classList.remove('is-in');
            nextPanel.classList.remove('is-in');

            window.setTimeout(() => {
              switching = false;
            },fadeMs);
          });
        });
      },Math.round(fadeMs * .7));
    }

    tabs.forEach(tab => {
      tab.addEventListener('click',() => activate(tab.dataset.tabId,false));
    });

    function initCard(card){
      if(card.dataset.cardReady === 'true') return;
      card.dataset.cardReady = 'true';

      const form = card.querySelector('.zlp5-card__form');
      const variantInput = card.querySelector('[data-variant-input]');
      const subscriptionVariantInput = card.querySelector('[data-subscription-variant-input]');
      const sellingPlanInput = card.querySelector('[data-selling-plan-input]');
      const optionButtons = [...card.querySelectorAll('[data-option-btn]')];
      const variantNodes = [...card.querySelectorAll('[data-variant-data]')];

      const subscription = card.querySelector('[data-subscription]');
      const subscriptionSwitch = card.querySelector('[data-subscription-switch]');
      const planToggle = card.querySelector('[data-plan-toggle]');
      const planPanel = card.querySelector('[data-plan-panel]');
      const subscriptionSummary = card.querySelector('[data-subscription-summary]');
      const subProductSelect = card.querySelector('[data-sub-product-select]');
      const planButtons = [...card.querySelectorAll('[data-plan-btn]')];

      const priceEl = card.querySelector('[data-card-price]');
      const singleOptionPrice = card.querySelector('[data-single-option-price]');
      const compareEl = card.querySelector('[data-card-compare]');
      const imageEl = card.querySelector('[data-card-image]');
      const badgeEl = card.querySelector('[data-card-badge]');
      const actionEl = card.querySelector('[data-card-add]');
      const productLink = card.querySelector('[data-product-link]');
      const quickToggle = card.querySelector('[data-quick-toggle]');
      const quickClose = card.querySelector('[data-quick-close]');
      const cartStatus = card.querySelector('[data-cart-status]');

      const sectionOneTimeText = root.dataset.oneTimeText || 'One-time purchase';
      const cartUrl = root.dataset.cartUrl || '/cart';

      let currentVariant = null;
      let subscriptionEnabled = false;
      let planExpanded = false;
      let lastSelectedPlanId = '';

      function selectedValues(){
        return [...card.querySelectorAll('[data-option-group]')].map(group => {
          const selected = group.querySelector('[data-option-btn].is-selected');
          return selected ? selected.dataset.optionValue : '';
        });
      }

      function findVariant(){
        const values = selectedValues();

        return variantNodes.find(node => {
          const options = [
            node.dataset.option1 || '',
            node.dataset.option2 || '',
            node.dataset.option3 || ''
          ];

          return values.every((value,index) => options[index] === value);
        }) || variantNodes[0] || null;
      }

      function selectedSubscriptionProduct(){
        if(!subProductSelect || !subProductSelect.options.length) return null;

        const option = subProductSelect.options[subProductSelect.selectedIndex];
        if(!option) return null;

        return {
          productId: option.dataset.subProductId || option.value || '',
          variantId: option.dataset.variantId || '',
          title: option.dataset.productTitle || option.textContent.trim(),
          price: option.dataset.productPrice || ''
        };
      }

      function visiblePlans(){
        const selectedProduct = selectedSubscriptionProduct();
        const visible = [];

        planButtons.forEach(button => {
          const show =
            !!selectedProduct &&
            button.dataset.subProductId === String(selectedProduct.productId) &&
            button.dataset.variantId === String(selectedProduct.variantId);

          button.hidden = !show;

          if(show){
            visible.push(button);
          }
        });

        return visible;
      }

      function setPlan(button){
        planButtons.forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-selected',selected);
          item.setAttribute('aria-pressed',selected ? 'true' : 'false');
        });

        if(!sellingPlanInput) return;

        if(!button){
          sellingPlanInput.value = '';

          if(subscriptionSummary){
            subscriptionSummary.textContent = subscriptionEnabled
              ? 'Choose delivery frequency'
              : sectionOneTimeText;
          }

          return;
        }

        const planId = button.dataset.planId || '';
        const isPreviewPlan = button.dataset.previewPlan === 'true';
        const selectedProduct = selectedSubscriptionProduct();

        if(!isPreviewPlan && planId){
          lastSelectedPlanId = planId;
        }

        sellingPlanInput.value = planId;

        if(subscriptionSummary){
          const productTitle = selectedProduct ? selectedProduct.title : '';
          const planName = button.dataset.planName || '';
          subscriptionSummary.textContent =
            productTitle && planName
              ? productTitle + ' · ' + planName
              : (planName || productTitle);
        }
      }

      function setPlanExpanded(expanded){
        if(!subscription || !planToggle || !planPanel) return;

        if(!subscriptionEnabled){
          expanded = false;
        }

        planExpanded = !!expanded;
        subscription.classList.toggle('is-expanded',planExpanded);
        planToggle.setAttribute('aria-expanded',planExpanded ? 'true' : 'false');
        planPanel.hidden = !planExpanded;
      }

      function syncSubscriptionProduct(){
        if(!subscription) return;

        const selectedProduct = selectedSubscriptionProduct();

        if(subscriptionVariantInput){
          subscriptionVariantInput.value = selectedProduct ? selectedProduct.variantId : '';
        }

        const plans = visiblePlans();

        if(!selectedProduct || !plans.length){
          if(!window.Shopify || !window.Shopify.designMode){
            subscription.hidden = true;
          }
          setPlan(null);
          return;
        }

        subscription.hidden = false;

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);
        }else{
          setPlan(null);
        }
      }

      function setSubscriptionEnabled(enabled, keepDropdownClosed){
        if(!subscription || !subscriptionSwitch) return;

        const plans = visiblePlans();

        if(!plans.length){
          subscriptionEnabled = false;
          subscription.classList.remove('is-enabled');
          subscriptionSwitch.setAttribute('aria-pressed','false');
          setPlanExpanded(false);
          setPlan(null);
          return;
        }

        subscriptionEnabled = !!enabled;
        subscription.classList.toggle('is-enabled',subscriptionEnabled);
        subscriptionSwitch.setAttribute('aria-pressed',subscriptionEnabled ? 'true' : 'false');

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);

          if(keepDropdownClosed !== false){
            setPlanExpanded(false);
          }
        }else{
          setPlanExpanded(false);
          setPlan(null);
        }
      }

      function updateLink(){
        if(!productLink || !currentVariant) return;

        const url = new URL(productLink.href,window.location.origin);
        url.searchParams.set('variant',currentVariant.dataset.id);
        url.searchParams.delete('selling_plan');

        productLink.href = url.pathname + url.search;
      }

      function syncVariant(){
        const variant = findVariant();
        if(!variant) return;

        currentVariant = variant;

        if(variantInput){
          variantInput.value = variant.dataset.id || '';
        }

        if(priceEl){
          priceEl.textContent = variant.dataset.price || '';
        }

        if(singleOptionPrice){
          singleOptionPrice.textContent = variant.dataset.price || '';
        }

        if(compareEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price){
            compareEl.textContent = variant.dataset.compare || '';
            compareEl.classList.remove('is-hidden');
          }else{
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        if(imageEl && variant.dataset.image){
          imageEl.src = variant.dataset.image;
          imageEl.removeAttribute('srcset');
        }

        if(badgeEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price && compare > 0){
            badgeEl.textContent = Math.round(((compare - price) / compare) * 100) + '% OFF';
            badgeEl.hidden = false;
          }else{
            badgeEl.hidden = true;
          }
        }

        if(actionEl){
          actionEl.disabled = variant.dataset.available !== 'true';
        }

        updateLink();
      }

      function setStatus(message,isError){
        if(!cartStatus) return;
        cartStatus.textContent = message || '';
        cartStatus.classList.toggle('is-error',!!isError);
      }

      optionButtons.forEach(button => {
        button.addEventListener('click',() => {
          const index = button.dataset.optionIndex;

          optionButtons
            .filter(x => x.dataset.optionIndex === index)
            .forEach(x => {
              const selected = x === button;
              x.classList.toggle('is-selected',selected);
              x.setAttribute('aria-pressed',selected ? 'true' : 'false');
            });

          syncVariant();
        });
      });

      if(subProductSelect){
        subProductSelect.addEventListener('change',() => {
          lastSelectedPlanId = '';
          syncSubscriptionProduct();

          if(subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }
        });
      }

      planButtons.forEach(button => {
        button.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlan(button);
          setPlanExpanded(false);
        });
      });

      if(subscriptionSwitch){
        subscriptionSwitch.addEventListener('click',(event) => {
          event.stopPropagation();
          setSubscriptionEnabled(!subscriptionEnabled,true);
        });
      }

      if(planToggle){
        planToggle.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlanExpanded(!planExpanded);
        });
      }

      if(quickToggle){
        quickToggle.addEventListener('click',() => {
          const open = !card.classList.contains('is-open');
          card.classList.toggle('is-open',open);
          quickToggle.setAttribute('aria-expanded',open ? 'true' : 'false');
        });
      }

      if(quickClose){
        quickClose.addEventListener('click',() => {
          card.classList.remove('is-open');

          if(quickToggle){
            quickToggle.setAttribute('aria-expanded','false');
          }
        });
      }

      if(form && actionEl){
        form.addEventListener('submit',async event => {
          event.preventDefault();
          setStatus('',false);

          if(!currentVariant || currentVariant.dataset.available !== 'true'){
            setStatus('This product is currently unavailable.',true);
            return;
          }

          const items = [{
            id: Number(currentVariant.dataset.id),
            quantity: 1
          }];

          if(subscriptionEnabled){
            const subVariantId = Number(subscriptionVariantInput ? subscriptionVariantInput.value : 0);
            const sellingPlanId = Number(sellingPlanInput ? sellingPlanInput.value : 0);

            if(!subVariantId || !sellingPlanId){
              setStatus('Please choose an available subscription product and delivery frequency.',true);
              setPlanExpanded(true);
              return;
            }

            items.push({
              id: subVariantId,
              quantity: 1,
              selling_plan: sellingPlanId
            });
          }

          const originalText = actionEl.textContent;
          actionEl.disabled = true;
          actionEl.textContent = 'ADDING...';

          try{
            const base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

            const response = await fetch(base + 'cart/add.js',{
              method:'POST',
              headers:{
                'Content-Type':'application/json',
                'Accept':'application/json'
              },
              body:JSON.stringify({items})
            });

            const data = await response.json();

            if(!response.ok){
              throw new Error(data && (data.description || data.message) ? (data.description || data.message) : 'Unable to add items.');
            }

            window.location.href = cartUrl;
          }catch(error){
            actionEl.disabled = false;
            actionEl.textContent = originalText;
            setStatus(error && error.message ? error.message : 'Unable to add items. Please try again.',true);
          }
        });
      }

      syncVariant();
      syncSubscriptionProduct();

      if(subscription && visiblePlans().length){
        setSubscriptionEnabled(true,true);
        setPlanExpanded(false);
      }
    }

    root.querySelectorAll('[data-zlp5-card]').forEach(initCard);

    function updateCountdowns(){
      if(root.dataset.countdownEnabled !== 'true') return;

      const endValue = root.dataset.countdownEnd;
      if(!endValue) return;

      const end = new Date(endValue).getTime();
      if(Number.isNaN(end)) return;

      const now = Date.now();
      let diff = Math.max(0,end - now);

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;

      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;

      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;

      const seconds = Math.floor(diff / 1000);

      const text =
        (days > 0 ? days + 'd ' : '') +
        String(hours).padStart(2,'0') + ':' +
        String(minutes).padStart(2,'0') + ':' +
        String(seconds).padStart(2,'0');

      root.querySelectorAll('[data-countdown]').forEach(node => {
        node.textContent = text;
      });
    }

    updateCountdowns();

    if(root.dataset.countdownEnabled === 'true'){
      root._zlp5Timer = window.setInterval(updateCountdowns,1000);
    }
  }

  function initAll(scope){
    const area = scope || document;

    if(area.matches && area.matches('[data-zlp5-root]')){
      initSection(area);
    }

    area.querySelectorAll('[data-zlp5-root]').forEach(initSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',() => initAll(document));
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',event => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload',event => {
    const root = event.target.querySelector('[data-zlp5-root]');

    if(root && root._zlp5Timer){
      window.clearInterval(root._zlp5Timer);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zxc-zxc-zxc"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(root){
    if(!root || root.dataset.zlp5Ready === 'true') return;
    root.dataset.zlp5Ready = 'true';

    const tabs = [...root.querySelectorAll('[data-zlp5-tab]')];
    const headers = [...root.querySelectorAll('[data-zlp5-header]')];
    const panels = [...root.querySelectorAll('[data-zlp5-panel]')];
    const productGrids = [...root.querySelectorAll('.zlp5__grid')];
    const gridToggle = root.querySelector('[data-zlp5-grid-toggle]');
    const gridIcon = root.querySelector('[data-zlp5-grid-icon]');
    const fadeMs = Math.max(120,Number(root.dataset.fadeMs || 220));
    let switching = false;
    let gridColumns = 3;

    function setGridColumns(columns){
      gridColumns = columns;

      productGrids.forEach(grid => {
        grid.style.setProperty('--zlp5-cols',String(columns));
      });

      if(gridToggle){
        gridToggle.setAttribute('aria-label','Show ' + columns + ' products per row. Click to change.');
        gridToggle.title = 'Show ' + columns + ' products per row';
      }
    }

    setGridColumns(3);

    if(gridToggle){
      gridToggle.addEventListener('click',() => {
        const next = gridColumns === 3 ? 4 : (gridColumns === 4 ? 5 : 3);
        setGridColumns(next);
      });
    }

    function activate(tabId,instant){
      const nextTab = tabs.find(x => x.dataset.tabId === tabId);
      const nextHeader = headers.find(x => x.dataset.tabId === tabId);
      const nextPanel = panels.find(x => x.dataset.tabId === tabId);
      const currentHeader = headers.find(x => !x.hidden);
      const currentPanel = panels.find(x => !x.hidden);

      if(!nextTab || !nextHeader || !nextPanel) return;
      if(currentPanel === nextPanel && currentHeader === nextHeader) return;
      if(switching && !instant) return;

      tabs.forEach(tab => {
        const active = tab === nextTab;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active ? 'true' : 'false');
      });

      if(instant || !currentHeader || !currentPanel){
        headers.forEach(header => {
          const active = header === nextHeader;
          header.hidden = !active;
          header.classList.toggle('is-active',active);
          header.classList.remove('is-in','is-out');
        });

        panels.forEach(panel => {
          const active = panel === nextPanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active',active);
          panel.classList.remove('is-in','is-out');
        });

        return;
      }

      switching = true;
      currentHeader.classList.add('is-out');
      currentPanel.classList.add('is-out');

      window.setTimeout(() => {
        currentHeader.hidden = true;
        currentHeader.classList.remove('is-active','is-out');

        currentPanel.hidden = true;
        currentPanel.classList.remove('is-active','is-out');

        nextHeader.hidden = false;
        nextPanel.hidden = false;

        nextHeader.classList.add('is-active','is-in');
        nextPanel.classList.add('is-active','is-in');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            nextHeader.classList.remove('is-in');
            nextPanel.classList.remove('is-in');

            window.setTimeout(() => {
              switching = false;
            },fadeMs);
          });
        });
      },Math.round(fadeMs * .7));
    }

    tabs.forEach(tab => {
      tab.addEventListener('click',() => activate(tab.dataset.tabId,false));
    });

    function initCard(card){
      if(card.dataset.cardReady === 'true') return;
      card.dataset.cardReady = 'true';

      const form = card.querySelector('.zlp5-card__form');
      const variantInput = card.querySelector('[data-variant-input]');
      const subscriptionVariantInput = card.querySelector('[data-subscription-variant-input]');
      const sellingPlanInput = card.querySelector('[data-selling-plan-input]');
      const optionButtons = [...card.querySelectorAll('[data-option-btn]')];
      const variantNodes = [...card.querySelectorAll('[data-variant-data]')];

      const subscription = card.querySelector('[data-subscription]');
      const subscriptionSwitch = card.querySelector('[data-subscription-switch]');
      const planToggle = card.querySelector('[data-plan-toggle]');
      const planPanel = card.querySelector('[data-plan-panel]');
      const subscriptionSummary = card.querySelector('[data-subscription-summary]');
      const subProductSelect = card.querySelector('[data-sub-product-select]');
      const planButtons = [...card.querySelectorAll('[data-plan-btn]')];

      const priceEl = card.querySelector('[data-card-price]');
      const singleOptionPrice = card.querySelector('[data-single-option-price]');
      const compareEl = card.querySelector('[data-card-compare]');
      const imageEl = card.querySelector('[data-card-image]');
      const badgeEl = card.querySelector('[data-card-badge]');
      const actionEl = card.querySelector('[data-card-add]');
      const productLink = card.querySelector('[data-product-link]');
      const quickToggle = card.querySelector('[data-quick-toggle]');
      const quickClose = card.querySelector('[data-quick-close]');
      const cartStatus = card.querySelector('[data-cart-status]');

      const sectionOneTimeText = root.dataset.oneTimeText || 'One-time purchase';
      const cartUrl = root.dataset.cartUrl || '/cart';

      let currentVariant = null;
      let subscriptionEnabled = false;
      let planExpanded = false;
      let lastSelectedPlanId = '';

      function selectedValues(){
        return [...card.querySelectorAll('[data-option-group]')].map(group => {
          const selected = group.querySelector('[data-option-btn].is-selected');
          return selected ? selected.dataset.optionValue : '';
        });
      }

      function findVariant(){
        const values = selectedValues();

        return variantNodes.find(node => {
          const options = [
            node.dataset.option1 || '',
            node.dataset.option2 || '',
            node.dataset.option3 || ''
          ];

          return values.every((value,index) => options[index] === value);
        }) || variantNodes[0] || null;
      }

      function selectedSubscriptionProduct(){
        if(!subProductSelect || !subProductSelect.options.length) return null;

        const option = subProductSelect.options[subProductSelect.selectedIndex];
        if(!option) return null;

        return {
          productId: option.dataset.subProductId || option.value || '',
          variantId: option.dataset.variantId || '',
          title: option.dataset.productTitle || option.textContent.trim(),
          price: option.dataset.productPrice || ''
        };
      }

      function visiblePlans(){
        const selectedProduct = selectedSubscriptionProduct();
        const visible = [];

        planButtons.forEach(button => {
          const show =
            !!selectedProduct &&
            button.dataset.subProductId === String(selectedProduct.productId) &&
            button.dataset.variantId === String(selectedProduct.variantId);

          button.hidden = !show;

          if(show){
            visible.push(button);
          }
        });

        return visible;
      }

      function setPlan(button){
        planButtons.forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-selected',selected);
          item.setAttribute('aria-pressed',selected ? 'true' : 'false');
        });

        if(!sellingPlanInput) return;

        if(!button){
          sellingPlanInput.value = '';

          if(subscriptionSummary){
            subscriptionSummary.textContent = subscriptionEnabled
              ? (root.dataset.subscriptionDefaultText || 'Every 1 Month')
              : sectionOneTimeText;
          }

          return;
        }

        const planId = button.dataset.planId || '';
        const isPreviewPlan = button.dataset.previewPlan === 'true';
        const selectedProduct = selectedSubscriptionProduct();

        if(!isPreviewPlan && planId){
          lastSelectedPlanId = planId;
        }

        sellingPlanInput.value = planId;

        if(subscriptionSummary){
          const productTitle = selectedProduct ? selectedProduct.title : '';
          const planName = button.dataset.planName || '';
          subscriptionSummary.textContent = planName || productTitle;
        }
      }

      function setPlanExpanded(expanded){
        if(!subscription || !planToggle || !planPanel) return;

        if(!subscriptionEnabled){
          expanded = false;
        }

        planExpanded = !!expanded;
        subscription.classList.toggle('is-expanded',planExpanded);
        planToggle.setAttribute('aria-expanded',planExpanded ? 'true' : 'false');
        planPanel.hidden = !planExpanded;
      }

      function syncSubscriptionProduct(){
        if(!subscription) return;

        const selectedProduct = selectedSubscriptionProduct();

        if(subscriptionVariantInput){
          subscriptionVariantInput.value = selectedProduct ? selectedProduct.variantId : '';
        }

        const plans = visiblePlans();

        if(!selectedProduct || !plans.length){
          if(!window.Shopify || !window.Shopify.designMode){
            subscription.hidden = true;
          }
          setPlan(null);
          return;
        }

        subscription.hidden = false;

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);
        }else{
          setPlan(null);
        }
      }

      function setSubscriptionEnabled(enabled, keepDropdownClosed){
        if(!subscription || !subscriptionSwitch) return;

        const plans = visiblePlans();

        if(!plans.length){
          subscriptionEnabled = false;
          subscription.classList.remove('is-enabled');
          subscriptionSwitch.setAttribute('aria-pressed','false');
          setPlanExpanded(false);
          setPlan(null);
          return;
        }

        subscriptionEnabled = !!enabled;
        subscription.classList.toggle('is-enabled',subscriptionEnabled);
        subscriptionSwitch.setAttribute('aria-pressed',subscriptionEnabled ? 'true' : 'false');

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);

          if(keepDropdownClosed !== false){
            setPlanExpanded(false);
          }
        }else{
          setPlanExpanded(false);
          setPlan(null);
        }
      }

      function updateLink(){
        if(!productLink || !currentVariant) return;

        const url = new URL(productLink.href,window.location.origin);
        url.searchParams.set('variant',currentVariant.dataset.id);
        url.searchParams.delete('selling_plan');

        productLink.href = url.pathname + url.search;
      }

      function syncVariant(){
        const variant = findVariant();
        if(!variant) return;

        currentVariant = variant;

        if(variantInput){
          variantInput.value = variant.dataset.id || '';
        }

        if(priceEl){
          priceEl.textContent = variant.dataset.price || '';
        }

        if(singleOptionPrice){
          singleOptionPrice.textContent = variant.dataset.price || '';
        }

        if(compareEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price){
            compareEl.textContent = variant.dataset.compare || '';
            compareEl.classList.remove('is-hidden');
          }else{
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        if(imageEl && variant.dataset.image){
          imageEl.src = variant.dataset.image;
          imageEl.removeAttribute('srcset');
        }

        if(badgeEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price && compare > 0){
            badgeEl.textContent = Math.round(((compare - price) / compare) * 100) + '% OFF';
            badgeEl.hidden = false;
          }else{
            badgeEl.hidden = true;
          }
        }

        if(actionEl){
          actionEl.disabled = variant.dataset.available !== 'true';
        }

        updateLink();
      }

      function setStatus(message,isError){
        if(!cartStatus) return;
        cartStatus.textContent = message || '';
        cartStatus.classList.toggle('is-error',!!isError);
      }

      optionButtons.forEach(button => {
        button.addEventListener('click',() => {
          const index = button.dataset.optionIndex;

          optionButtons
            .filter(x => x.dataset.optionIndex === index)
            .forEach(x => {
              const selected = x === button;
              x.classList.toggle('is-selected',selected);
              x.setAttribute('aria-pressed',selected ? 'true' : 'false');
            });

          syncVariant();
        });
      });

      if(subProductSelect){
        subProductSelect.addEventListener('change',() => {
          lastSelectedPlanId = '';
          syncSubscriptionProduct();

          if(subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }
        });
      }

      planButtons.forEach(button => {
        button.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlan(button);
          setPlanExpanded(false);
        });
      });

      if(subscriptionSwitch){
        subscriptionSwitch.addEventListener('click',(event) => {
          event.stopPropagation();
          setSubscriptionEnabled(!subscriptionEnabled,true);
        });
      }

      if(planToggle){
        planToggle.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlanExpanded(!planExpanded);
        });
      }

      if(quickToggle){
        quickToggle.addEventListener('click',() => {
          const open = !card.classList.contains('is-open');
          card.classList.toggle('is-open',open);
          quickToggle.setAttribute('aria-expanded',open ? 'true' : 'false');
        });
      }

      if(quickClose){
        quickClose.addEventListener('click',() => {
          card.classList.remove('is-open');

          if(quickToggle){
            quickToggle.setAttribute('aria-expanded','false');
          }
        });
      }

      if(form && actionEl){
        form.addEventListener('submit',async event => {
          event.preventDefault();
          setStatus('',false);

          if(!currentVariant || currentVariant.dataset.available !== 'true'){
            setStatus('This product is currently unavailable.',true);
            return;
          }

          const items = [{
            id: Number(currentVariant.dataset.id),
            quantity: 1
          }];

          if(subscriptionEnabled){
            const subVariantId = Number(subscriptionVariantInput ? subscriptionVariantInput.value : 0);
            const sellingPlanId = Number(sellingPlanInput ? sellingPlanInput.value : 0);

            if(!subVariantId || !sellingPlanId){
              setStatus('Please choose an available subscription product and delivery frequency.',true);
              setPlanExpanded(true);
              return;
            }

            items.push({
              id: subVariantId,
              quantity: 1,
              selling_plan: sellingPlanId
            });
          }

          const originalText = actionEl.textContent;
          actionEl.disabled = true;
          actionEl.textContent = 'ADDING...';

          try{
            const base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

            const response = await fetch(base + 'cart/add.js',{
              method:'POST',
              headers:{
                'Content-Type':'application/json',
                'Accept':'application/json'
              },
              body:JSON.stringify({items})
            });

            const data = await response.json();

            if(!response.ok){
              throw new Error(data && (data.description || data.message) ? (data.description || data.message) : 'Unable to add items.');
            }

            window.location.href = cartUrl;
          }catch(error){
            actionEl.disabled = false;
            actionEl.textContent = originalText;
            setStatus(error && error.message ? error.message : 'Unable to add items. Please try again.',true);
          }
        });
      }

      syncVariant();
      syncSubscriptionProduct();

      if(subscription && visiblePlans().length){
        setSubscriptionEnabled(true,true);
        setPlanExpanded(false);
      }
    }

    root.querySelectorAll('[data-zlp5-card]').forEach(initCard);

    function updateCountdowns(){
      const nodes = Array.from(root.querySelectorAll('[data-countdown]'));

      if(root.dataset.countdownEnabled !== 'true'){
        nodes.forEach(node => {
          node.hidden = true;
          node.textContent = '';
        });
        return false;
      }

      const endValue = (root.dataset.countdownEnd || '').trim();
      if(!endValue){
        nodes.forEach(node => {
          node.hidden = true;
          node.textContent = '';
        });
        return false;
      }

      const end = new Date(endValue).getTime();
      if(Number.isNaN(end) || end <= Date.now()){
        nodes.forEach(node => {
          node.hidden = true;
          node.textContent = '';
        });
        return false;
      }

      let diff = end - Date.now();

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;

      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;

      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;

      const seconds = Math.floor(diff / 1000);

      const output =
        (days > 0 ? days + 'd ' : '') +
        String(hours).padStart(2,'0') + ':' +
        String(minutes).padStart(2,'0') + ':' +
        String(seconds).padStart(2,'0');

      nodes.forEach(node => {
        node.hidden = false;
        node.textContent = output;
      });

      return true;
    }

    const countdownActive = updateCountdowns();

    if(countdownActive){
      root._zlp5Timer = window.setInterval(() => {
        const keepRunning = updateCountdowns();
        if(!keepRunning && root._zlp5Timer){
          window.clearInterval(root._zlp5Timer);
          root._zlp5Timer = null;
        }
      },1000);
    }
  }

  function initAll(scope){
    const area = scope || document;

    if(area.matches && area.matches('[data-zlp5-root]')){
      initSection(area);
    }

    area.querySelectorAll('[data-zlp5-root]').forEach(initSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',() => initAll(document));
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',event => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload',event => {
    const root = event.target.querySelector('[data-zlp5-root]');

    if(root && root._zlp5Timer){
      window.clearInterval(root._zlp5Timer);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zym-cp-zst"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(root){
    if(!root || root.dataset.zlp5Ready === 'true') return;
    root.dataset.zlp5Ready = 'true';

    const tabs = [...root.querySelectorAll('[data-zlp5-tab]')];
    const headers = [...root.querySelectorAll('[data-zlp5-header]')];
    const panels = [...root.querySelectorAll('[data-zlp5-panel]')];
    const fadeMs = Math.max(120,Number(root.dataset.fadeMs || 220));
    let switching = false;

    function activate(tabId,instant){
      const nextTab = tabs.find(x => x.dataset.tabId === tabId);
      const nextHeader = headers.find(x => x.dataset.tabId === tabId);
      const nextPanel = panels.find(x => x.dataset.tabId === tabId);
      const currentHeader = headers.find(x => !x.hidden);
      const currentPanel = panels.find(x => !x.hidden);

      if(!nextTab || !nextHeader || !nextPanel) return;
      if(currentPanel === nextPanel && currentHeader === nextHeader) return;
      if(switching && !instant) return;

      tabs.forEach(tab => {
        const active = tab === nextTab;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',active ? 'true' : 'false');
      });

      if(instant || !currentHeader || !currentPanel){
        headers.forEach(header => {
          const active = header === nextHeader;
          header.hidden = !active;
          header.classList.toggle('is-active',active);
          header.classList.remove('is-in','is-out');
        });

        panels.forEach(panel => {
          const active = panel === nextPanel;
          panel.hidden = !active;
          panel.classList.toggle('is-active',active);
          panel.classList.remove('is-in','is-out');
        });

        return;
      }

      switching = true;
      currentHeader.classList.add('is-out');
      currentPanel.classList.add('is-out');

      window.setTimeout(() => {
        currentHeader.hidden = true;
        currentHeader.classList.remove('is-active','is-out');

        currentPanel.hidden = true;
        currentPanel.classList.remove('is-active','is-out');

        nextHeader.hidden = false;
        nextPanel.hidden = false;

        nextHeader.classList.add('is-active','is-in');
        nextPanel.classList.add('is-active','is-in');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            nextHeader.classList.remove('is-in');
            nextPanel.classList.remove('is-in');

            window.setTimeout(() => {
              switching = false;
            },fadeMs);
          });
        });
      },Math.round(fadeMs * .7));
    }

    tabs.forEach(tab => {
      tab.addEventListener('click',() => activate(tab.dataset.tabId,false));
    });

    function initCard(card){
      if(card.dataset.cardReady === 'true') return;
      card.dataset.cardReady = 'true';

      const form = card.querySelector('.zlp5-card__form');
      const variantInput = card.querySelector('[data-variant-input]');
      const subscriptionVariantInput = card.querySelector('[data-subscription-variant-input]');
      const sellingPlanInput = card.querySelector('[data-selling-plan-input]');
      const optionButtons = [...card.querySelectorAll('[data-option-btn]')];
      const variantNodes = [...card.querySelectorAll('[data-variant-data]')];

      const subscription = card.querySelector('[data-subscription]');
      const subscriptionSwitch = card.querySelector('[data-subscription-switch]');
      const planToggle = card.querySelector('[data-plan-toggle]');
      const planPanel = card.querySelector('[data-plan-panel]');
      const subscriptionSummary = card.querySelector('[data-subscription-summary]');
      const subProductSelect = card.querySelector('[data-sub-product-select]');
      const planButtons = [...card.querySelectorAll('[data-plan-btn]')];

      const priceEl = card.querySelector('[data-card-price]');
      const singleOptionPrice = card.querySelector('[data-single-option-price]');
      const compareEl = card.querySelector('[data-card-compare]');
      const imageEl = card.querySelector('[data-card-image]');
      const badgeEl = card.querySelector('[data-card-badge]');
      const actionEl = card.querySelector('[data-card-add]');
      const productLink = card.querySelector('[data-product-link]');
      const quickToggle = card.querySelector('[data-quick-toggle]');
      const quickClose = card.querySelector('[data-quick-close]');
      const cartStatus = card.querySelector('[data-cart-status]');

      const sectionOneTimeText = root.dataset.oneTimeText || 'One-time purchase';
      const cartUrl = root.dataset.cartUrl || '/cart';

      let currentVariant = null;
      let subscriptionEnabled = false;
      let planExpanded = false;
      let lastSelectedPlanId = '';

      function selectedValues(){
        return [...card.querySelectorAll('[data-option-group]')].map(group => {
          const selected = group.querySelector('[data-option-btn].is-selected');
          return selected ? selected.dataset.optionValue : '';
        });
      }

      function findVariant(){
        const values = selectedValues();

        return variantNodes.find(node => {
          const options = [
            node.dataset.option1 || '',
            node.dataset.option2 || '',
            node.dataset.option3 || ''
          ];

          return values.every((value,index) => options[index] === value);
        }) || variantNodes[0] || null;
      }

      function selectedSubscriptionProduct(){
        if(!subProductSelect || !subProductSelect.options.length) return null;

        const option = subProductSelect.options[subProductSelect.selectedIndex];
        if(!option) return null;

        return {
          productId: option.dataset.subProductId || option.value || '',
          variantId: option.dataset.variantId || '',
          title: option.dataset.productTitle || option.textContent.trim(),
          price: option.dataset.productPrice || ''
        };
      }

      function visiblePlans(){
        const selectedProduct = selectedSubscriptionProduct();
        const visible = [];

        planButtons.forEach(button => {
          const show =
            !!selectedProduct &&
            button.dataset.subProductId === String(selectedProduct.productId) &&
            button.dataset.variantId === String(selectedProduct.variantId);

          button.hidden = !show;

          if(show){
            visible.push(button);
          }
        });

        return visible;
      }

      function setPlan(button){
        planButtons.forEach(item => {
          const selected = item === button;
          item.classList.toggle('is-selected',selected);
          item.setAttribute('aria-pressed',selected ? 'true' : 'false');
        });

        if(!sellingPlanInput) return;

        if(!button){
          sellingPlanInput.value = '';

          if(subscriptionSummary){
            subscriptionSummary.textContent = subscriptionEnabled
              ? 'Choose delivery frequency'
              : sectionOneTimeText;
          }

          return;
        }

        const planId = button.dataset.planId || '';
        const isPreviewPlan = button.dataset.previewPlan === 'true';
        const selectedProduct = selectedSubscriptionProduct();

        if(!isPreviewPlan && planId){
          lastSelectedPlanId = planId;
        }

        sellingPlanInput.value = planId;

        if(subscriptionSummary){
          const productTitle = selectedProduct ? selectedProduct.title : '';
          const planName = button.dataset.planName || '';
          subscriptionSummary.textContent =
            productTitle && planName
              ? productTitle + ' · ' + planName
              : (planName || productTitle);
        }
      }

      function setPlanExpanded(expanded){
        if(!subscription || !planToggle || !planPanel) return;

        if(!subscriptionEnabled){
          expanded = false;
        }

        planExpanded = !!expanded;
        subscription.classList.toggle('is-expanded',planExpanded);
        planToggle.setAttribute('aria-expanded',planExpanded ? 'true' : 'false');
        planPanel.hidden = !planExpanded;
      }

      function syncSubscriptionProduct(){
        if(!subscription) return;

        const selectedProduct = selectedSubscriptionProduct();

        if(subscriptionVariantInput){
          subscriptionVariantInput.value = selectedProduct ? selectedProduct.variantId : '';
        }

        const plans = visiblePlans();

        if(!selectedProduct || !plans.length){
          if(!window.Shopify || !window.Shopify.designMode){
            subscription.hidden = true;
          }
          setPlan(null);
          return;
        }

        subscription.hidden = false;

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);
        }else{
          setPlan(null);
        }
      }

      function setSubscriptionEnabled(enabled, keepDropdownClosed){
        if(!subscription || !subscriptionSwitch) return;

        const plans = visiblePlans();

        if(!plans.length){
          subscriptionEnabled = false;
          subscription.classList.remove('is-enabled');
          subscriptionSwitch.setAttribute('aria-pressed','false');
          setPlanExpanded(false);
          setPlan(null);
          return;
        }

        subscriptionEnabled = !!enabled;
        subscription.classList.toggle('is-enabled',subscriptionEnabled);
        subscriptionSwitch.setAttribute('aria-pressed',subscriptionEnabled ? 'true' : 'false');

        if(subscriptionEnabled){
          const preferred =
            plans.find(button => button.dataset.planId && button.dataset.planId === lastSelectedPlanId) ||
            plans.find(button => button.classList.contains('is-selected')) ||
            plans[0];

          setPlan(preferred);

          if(keepDropdownClosed !== false){
            setPlanExpanded(false);
          }
        }else{
          setPlanExpanded(false);
          setPlan(null);
        }
      }

      function updateLink(){
        if(!productLink || !currentVariant) return;

        const url = new URL(productLink.href,window.location.origin);
        url.searchParams.set('variant',currentVariant.dataset.id);
        url.searchParams.delete('selling_plan');

        productLink.href = url.pathname + url.search;
      }

      function syncVariant(){
        const variant = findVariant();
        if(!variant) return;

        currentVariant = variant;

        if(variantInput){
          variantInput.value = variant.dataset.id || '';
        }

        if(priceEl){
          priceEl.textContent = variant.dataset.price || '';
        }

        if(singleOptionPrice){
          singleOptionPrice.textContent = variant.dataset.price || '';
        }

        if(compareEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price){
            compareEl.textContent = variant.dataset.compare || '';
            compareEl.classList.remove('is-hidden');
          }else{
            compareEl.textContent = '';
            compareEl.classList.add('is-hidden');
          }
        }

        if(imageEl && variant.dataset.image){
          imageEl.src = variant.dataset.image;
          imageEl.removeAttribute('srcset');
        }

        if(badgeEl){
          const price = Number(variant.dataset.priceCents || 0);
          const compare = Number(variant.dataset.compareCents || 0);

          if(compare > price && compare > 0){
            badgeEl.textContent = Math.round(((compare - price) / compare) * 100) + '% OFF';
            badgeEl.hidden = false;
          }else{
            badgeEl.hidden = true;
          }
        }

        if(actionEl){
          actionEl.disabled = variant.dataset.available !== 'true';
        }

        updateLink();
      }

      function setStatus(message,isError){
        if(!cartStatus) return;
        cartStatus.textContent = message || '';
        cartStatus.classList.toggle('is-error',!!isError);
      }

      optionButtons.forEach(button => {
        button.addEventListener('click',() => {
          const index = button.dataset.optionIndex;

          optionButtons
            .filter(x => x.dataset.optionIndex === index)
            .forEach(x => {
              const selected = x === button;
              x.classList.toggle('is-selected',selected);
              x.setAttribute('aria-pressed',selected ? 'true' : 'false');
            });

          syncVariant();
        });
      });

      if(subProductSelect){
        subProductSelect.addEventListener('change',() => {
          lastSelectedPlanId = '';
          syncSubscriptionProduct();

          if(subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }
        });
      }

      planButtons.forEach(button => {
        button.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlan(button);
          setPlanExpanded(false);
        });
      });

      if(subscriptionSwitch){
        subscriptionSwitch.addEventListener('click',(event) => {
          event.stopPropagation();
          setSubscriptionEnabled(!subscriptionEnabled,true);
        });
      }

      if(planToggle){
        planToggle.addEventListener('click',() => {
          if(!subscriptionEnabled){
            setSubscriptionEnabled(true,true);
          }

          setPlanExpanded(!planExpanded);
        });
      }

      if(quickToggle){
        quickToggle.addEventListener('click',() => {
          const open = !card.classList.contains('is-open');
          card.classList.toggle('is-open',open);
          quickToggle.setAttribute('aria-expanded',open ? 'true' : 'false');
        });
      }

      if(quickClose){
        quickClose.addEventListener('click',() => {
          card.classList.remove('is-open');

          if(quickToggle){
            quickToggle.setAttribute('aria-expanded','false');
          }
        });
      }

      if(form && actionEl){
        form.addEventListener('submit',async event => {
          event.preventDefault();
          setStatus('',false);

          if(!currentVariant || currentVariant.dataset.available !== 'true'){
            setStatus('This product is currently unavailable.',true);
            return;
          }

          const items = [{
            id: Number(currentVariant.dataset.id),
            quantity: 1
          }];

          if(subscriptionEnabled){
            const subVariantId = Number(subscriptionVariantInput ? subscriptionVariantInput.value : 0);
            const sellingPlanId = Number(sellingPlanInput ? sellingPlanInput.value : 0);

            if(!subVariantId || !sellingPlanId){
              setStatus('Please choose an available subscription product and delivery frequency.',true);
              setPlanExpanded(true);
              return;
            }

            items.push({
              id: subVariantId,
              quantity: 1,
              selling_plan: sellingPlanId
            });
          }

          const originalText = actionEl.textContent;
          actionEl.disabled = true;
          actionEl.textContent = 'ADDING...';

          try{
            const base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

            const response = await fetch(base + 'cart/add.js',{
              method:'POST',
              headers:{
                'Content-Type':'application/json',
                'Accept':'application/json'
              },
              body:JSON.stringify({items})
            });

            const data = await response.json();

            if(!response.ok){
              throw new Error(data && (data.description || data.message) ? (data.description || data.message) : 'Unable to add items.');
            }

            window.location.href = cartUrl;
          }catch(error){
            actionEl.disabled = false;
            actionEl.textContent = originalText;
            setStatus(error && error.message ? error.message : 'Unable to add items. Please try again.',true);
          }
        });
      }

      syncVariant();
      syncSubscriptionProduct();

      if(subscription && visiblePlans().length){
        setSubscriptionEnabled(true,true);
        setPlanExpanded(false);
      }
    }

    root.querySelectorAll('[data-zlp5-card]').forEach(initCard);

    function updateCountdowns(){
      if(root.dataset.countdownEnabled !== 'true') return;

      const endValue = root.dataset.countdownEnd;
      if(!endValue) return;

      const end = new Date(endValue).getTime();
      if(Number.isNaN(end)) return;

      const now = Date.now();
      let diff = Math.max(0,end - now);

      const days = Math.floor(diff / 86400000);
      diff -= days * 86400000;

      const hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;

      const minutes = Math.floor(diff / 60000);
      diff -= minutes * 60000;

      const seconds = Math.floor(diff / 1000);

      const text =
        (days > 0 ? days + 'd ' : '') +
        String(hours).padStart(2,'0') + ':' +
        String(minutes).padStart(2,'0') + ':' +
        String(seconds).padStart(2,'0');

      root.querySelectorAll('[data-countdown]').forEach(node => {
        node.textContent = text;
      });
    }

    updateCountdowns();

    if(root.dataset.countdownEnabled === 'true'){
      root._zlp5Timer = window.setInterval(updateCountdowns,1000);
    }
  }

  function initAll(scope){
    const area = scope || document;

    if(area.matches && area.matches('[data-zlp5-root]')){
      initSection(area);
    }

    area.querySelectorAll('[data-zlp5-root]').forEach(initSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',() => initAll(document));
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',event => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload',event => {
    const root = event.target.querySelector('[data-zlp5-root]');

    if(root && root._zlp5Timer){
      window.clearInterval(root._zlp5Timer);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
